export default __webpack_public_path__ + "static/media/linkedin-icon.32e20978.svg";